import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./reducers/userReducer";
import announcementReducer from "./reducers/announcementReducer";
import tesReducer from "./reducers/tesReducer";
import dashboardReducers from "./reducers/dashboardReducers";

const persistConfig = {
  key: "root",
  version: 1,
  blacklist: ["user", "announcement", "tes", "dashboard"],
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  announcement: announcementReducer,
  tes: tesReducer,
  dashboard: dashboardReducers,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "user/login/fulfilled",
          "user/login/rejected",
          "user/auth/rejected",
          "user/auth/fulfilled",
          "user/logout/rejected",
          "user/logout/fulfilled",
          "user/profile/rejected",
          "user/profile/fulfilled",
          "user/profileSekolah/fulfilled",
          "user/profileSekolah/rejected",
          "announcement/list/fulfilled",
          "announcement/list/rejected",
          "announcement/detail/fulfilled",
          "announcement/detail/rejected",
          "tes/list/fulfilled",
          "tes/list/rejected",
          "tes/detail/fulfilled",
          "tes/detail/rejected",
          "dashboard/dashboard/fulfilled",
          "dashboard/dashboard/rejected",
        ],
        ignoredPaths: ["payload.config.adapter"],
      },
    }),
});

export const persistor = persistStore(store);
